import {ShouldRevalidateFunction} from 'react-router-dom'

let forceRevalidate = true

export function markPlantForRevalidation() {
  forceRevalidate = true
}

export const plantRevalidator: ShouldRevalidateFunction = ({
  currentParams,
  nextParams,
  formMethod,
}) => {
  if (formMethod === 'post' || formMethod === 'delete') {
    return true
  }

  if (forceRevalidate) {
    forceRevalidate = false
    return true
  }

  return currentParams.plantId != nextParams.plantId
}
